module.exports = __webpack_public_path__ + "img/phon4-caipu.d490fe9c.png";